import { render, staticRenderFns } from "./CGVData.vue?vue&type=template&id=d937e624&scoped=true"
import script from "./CGVData.vue?vue&type=script&lang=js"
export * from "./CGVData.vue?vue&type=script&lang=js"
import style0 from "./CGVData.vue?vue&type=style&index=0&id=d937e624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d937e624",
  null
  
)

export default component.exports